import {observable, action, runInAction} from 'mobx'
import {get} from '../../../../utils/ajax'

class UserManualContentsStore {

    @observable loading
    @observable content //目录内容
    @observable carseriesName //车系名称
    @observable carseriesId //车系ID
    @observable level1Directory //1级目录
    @observable childrenDirectory //下级目录
    @observable directoryName //目录名称
    @observable level1Selected //选中的1级目录
    @observable childrenSelected //选中下级目录
    @observable openKeys //开启
    @observable contentId //内容id
    @observable fileName //文件名称
    @observable uploadAddressId //下载地址

    constructor() {
        this.loading = false
        this.content = []
        this.carseriesName = ''
        this.carseriesId = ''
        this.level1Directory = []
        this.childrenDirectory = []
        this.directoryName = ''
        this.level1Selected = ''
        this.childrenSelected = ''
        this.openKeys = []
        this.contentId = ''
        this.fileName = ''
        this.uploadAddressId = ''
    }

    /**查询车系数据**/
    @action
    init = async (carseriesId, level1Selected, catalogId) => {
        runInAction(() => {
            this.content = [];
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCarseriesCatalog/id/${carseriesId}`)
        if (res && res.status === 0) {
            return;
        }
        runInAction(() => {
            this.carseriesName = res.carseriesName
        })
        await this.findDirectoryByDirectoryId(carseriesId, level1Selected, catalogId)
    }

    /**按目录 ID 查找目录**/
    findDirectoryByDirectoryId = async (carseriesId, level1Selected, catalogId) => {
        runInAction(() => {
            this.loading = true
            this.carseriesId = carseriesId
            this.level1Directory = [];
            this.childrenDirectory = [];
            this.catalogName = '';
            this.content = [];
        })
        let catalog;
        if (catalogId && catalogId !== 'none') {
            catalog = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/selectById/${catalogId}`)
        } else {
            catalog = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/queryTheLowestLevelDirectoryAccordingToTheCarId/${carseriesId}`)
        }
        if (catalog && catalog.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        const level1Directory = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/queryTheLevel1DirectoryAccordingToTheCarCode?carseriesId=${carseriesId}`)
        if (!level1Directory.length) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        const childrenDirectory = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/childrenList`, {
            carseriesId: carseriesId,
            pId: level1Directory[0].id
        })
        if (!childrenDirectory.length) {
            runInAction(() => {
                this.loading = false
            })
            return;
        }
        const content = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualDocumentContent/queryByDirectoryId/${catalog.id}`)
        runInAction(() => {
            this.level1Directory = level1Directory
            this.childrenDirectory = childrenDirectory
            this.level1Selected = level1Selected === 'none' ? level1Directory[0].id : level1Selected
            this.childrenSelected = catalog.id
            this.content = [content]
            this.openKeys = [childrenDirectory[0].id, catalog.pid]
            this.directoryName = catalog.name
            this.contentId = content.id
            this.uploadAddressId=content.uploadAddress
            this.fileName = content.name
            this.loading = false
        })
    }

    /**展开中间层级**/
    @action
    openMenu = (openKeys) => {
        this.openKeys = openKeys
    }

    /**点击1级目录**/
    @action
    getChildrenTree = async (level1Selected) => {
        runInAction(() => {
            this.loading = true
        })
        const catalog = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/queryTheLowerLevelAccordingToTheVehicleId1LevelDirectory`, {
            carseriesId: this.carseriesId,
            catalogId: level1Selected
        })
        const childrenDirectory = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/childrenList`, {
            carseriesId: this.carseriesId,
            pId: level1Selected
        })
        if (!childrenDirectory.length) {
            runInAction(() => {
                this.loading = false
            })
            return;
        }
        const content = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualDocumentContent/queryByDirectoryId/${catalog.id}`)
        runInAction(() => {
            this.childrenDirectory = childrenDirectory
            this.level1Selected = level1Selected
            this.childrenSelected = catalog.id
            this.content = [content]
            this.openKeys = [childrenDirectory[0].id, catalog.pid]
            this.directoryName = catalog.name
            this.contentId = content.id
            this.fileName = content.name
            this.loading = false
        })
    }

    /**点击左侧目录最后一层**/
    @action
    showContent = async (id, name) => {
        runInAction(() => {
            this.loading = true
        })
        const content = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualDocumentContent/queryByDirectoryId/${id}`)
        runInAction(() => {
            this.childrenSelected = id
            this.content = [content]
            this.directoryName = name
            this.contentId = content.id
            this.fileName = content.name
            this.loading = false
        })
    }

}

export default new UserManualContentsStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/manual/Content/store.js